import { render, staticRenderFns } from "./Root.vue?vue&type=template&id=3b5aa2ca&"
import script from "./Root.vue?vue&type=script&lang=ts&"
export * from "./Root.vue?vue&type=script&lang=ts&"
import style0 from "./Root.vue?vue&type=style&index=0&id=3b5aa2ca&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports